// Effect Managers
import { call, put } from 'redux-saga/effects'

// Libs
import _identity from 'lodash/identity'
import _uniqueId from 'lodash/uniqueId'
import moment from 'moment'

// fc-requests module
import {
  PROP_END,
  PROP_CODE,
  PROP_ERRORS,
  PROP_STATUS,
  PROP_RESPONSE,
  PROP_MODEL_ID,
  SUCCESS,
  ERROR,
  createRequest,
  updateRequests,
  createRequestInfo} from 'fc-requests'

// Fetch Saga Composer
export default function composeFetchSaga ({
  getWorker,
  onMessage,
  preProcessMessage = _identity,
}) {
  function postMessage (message) {
    const { messageId } = message
    return new Promise((resolve) => {
      const worker = getWorker()

      function on ({data}) {
        if (data.messageId === messageId) {
          worker.removeEventListener('message', on)

          resolve(data)

          if (typeof onMessage === 'function') {
            onMessage({data, worker})
          }
        }
      }

      worker.addEventListener('message', on)

      worker.postMessage(message)
    })
  }

  return function *fetch ({url, queryParams, id, token, body, method = 'GET', meta, ...other}) {
    const messageId = _uniqueId()

    const message = yield call(preProcessMessage, {
      ...other,
      url,
      token,
      queryParams,
      id,
      body,
      method,
      messageId,
    })

    const infoObject = yield createRequestInfo(message)

    const createRequestAction = yield call(createRequest, infoObject)
    yield put(createRequestAction)

    const response = yield call(postMessage, message)

    const updateInfoObject = {
      ...infoObject,
      [PROP_END]: moment().unix(),
      [PROP_CODE]: response.status,
      [PROP_ERRORS]: response.bad,
      [PROP_STATUS]: response.status === 200 ? SUCCESS : ERROR,
      [PROP_RESPONSE]: response.response,
      [PROP_MODEL_ID]: response.model,
    }

    const updateInfoObjectAction = yield call(updateRequests, updateInfoObject)
    yield put(updateInfoObjectAction)

    return response
  }
}
